<template>
    <div :class="['px-2', expandable ? '' : 'mt-5']">
        <div class="col-12 px-2">
            <template v-if="!expandable">
                <h4>
                    <i class="fa fa-history" aria-hidden="true"></i>
                    {{$lang('Historia zgłoszenia')}}
                </h4>
                <hr class="colorgraph">
            </template>
            <toast-history class="mb-2 print-no-break" :key="index" v-for="(hist, index) in histories" :history="hist" :admin="admin"></toast-history>
        </div>
    </div>
</template>

<script>
import ToastHistory from "./toast-history";
export default {
    name: "history-section",
    components: {ToastHistory},
    props: {
        histories: {
            type: Array,
            required: true
        },
        admin: {
            type: Number,
            required: true
        },
        expandable: {
            type: Boolean,
            required: false,
            default: false
        }
    }
}
</script>

<style scoped>

</style>
